import { Theme } from '@material-ui/core/styles';

type GridReturn = { MuiGrid: { styleOverrides: Record<string, never> } }

export const Grid = (theme: Theme): GridReturn => ({
  MuiGrid: {
    styleOverrides: {},
  },
});
